<template>
  <Switch
    v-model="enabled"
    :disabled="disabled"
    :class="[
      enabled ? `bg-${activeColor}-500` : startingBgColor,
      'relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none',
      disabled ? 'cursor-not-allowed' : 'cursor-pointer',
    ]"
  >
    <span class="sr-only">Use setting</span>
    <span
      :class="[
        enabled ? 'translate-x-5' : 'translate-x-0',
        'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
      ]"
    >
      <span
        :class="[
          enabled
            ? 'opacity-0 duration-100 ease-out'
            : 'opacity-100 duration-200 ease-in',
          'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity',
        ]"
        aria-hidden="true"
      ></span>
      <span
        :class="[
          enabled
            ? 'opacity-100 duration-200 ease-in'
            : 'opacity-0 duration-100 ease-out',
          'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity',
        ]"
        aria-hidden="true"
      ></span>

      <div
        v-if="includeIcons"
        class="flex h-full items-center justify-center"
      >
        <img
          v-if="enabled"
          class="h-2 w-2"
          src="@/assets/switch-check.svg"
          alt="check icon"
        />
        <img
          v-else
          class="h-2 w-2"
          src="@/assets/switch-x.svg"
          alt="x icon"
        />
      </div>
    </span>
  </Switch>
</template>

<script>
import { Switch } from '@headlessui/vue';

export default {
  props: {
    bgClass: String,
    includeIcons: Boolean,
    activeColor: {
      type: String,
      default: 'yellow',
    },
    modelValue: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      enabled: this.modelValue,
      startingBgColor: 'bg-light-gray',
    };
  },
  components: {
    Switch,
  },
  computed: {
    textColorClass() {
      return 'text-' + this.activeColor + '-500';
    },
  },
  mounted() {
    this.applyBgClass();
  },
  methods: {
    applyBgClass: function () {
      if (this.bgClass) {
        this.startingBgColor = this.bgClass;
      }
    },
  },
  watch: {
    modelValue: function (newValue) {
      this.enabled = newValue;
    },
    enabled: function (newValue) {
      this.$emit('update:modelValue', newValue);
    },
  },
  emits: ['update:modelValue'],
};
</script>
